var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "h-full" },
    [
      _c(
        "v-card-text",
        {
          staticClass: "d-flex flex-column h-full pa-0",
          class: _vm.checking ? "justify-center" : ""
        },
        [
          !_vm.checking
            ? [
                _c(
                  "legacy-title",
                  {
                    staticClass: "pa-4 mt-3 title-branding",
                    attrs: { border: "" }
                  },
                  [_vm._v("\n                KeyPlan in Action\n            ")]
                ),
                _vm._v(" "),
                !_vm.client.product
                  ? [
                      _c("p", { staticClass: "px-4" }, [
                        _vm._v(
                          "\n                    Select a plan to see your benefits\n                "
                        )
                      ])
                    ]
                  : [_c("attributes")]
              ]
            : [
                _c(
                  "div",
                  { staticClass: "text-center" },
                  [
                    _c("v-progress-circular", {
                      attrs: {
                        color: _vm.$vuetify.theme.dark
                          ? "secondary"
                          : "primary",
                        size: 50,
                        indeterminate: ""
                      }
                    })
                  ],
                  1
                )
              ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }